export const SET_SEARCH_CRITERIA = 'SET_SEARCH_CRITERIA';
export const IS_BACK_CLICKED = 'IS_BACK_CLICKED';
export const CLEAR_SEARCH_CRITERIA = 'CLEAR_SEARCH_CRITERIA';
